export default {
  numberOfBoxQuestion: 'Connaissez vous le nombre de cartons à déménager ?',
  numberOfRooms: 'De combien de pièces est constitué votre logement ?',
  numberOfPeople: 'Combien de personnes sont concernées par le déménagement ?',
  dontKnowNumberOfBox: 'Non, aidez moi à calculer',
  noBoxToCarry: 'Aucun carton à déménager',
  numberOfRoomQuestion: 'De combien de pièces est constitué votre logement ?',
  numberOfBoxesQuestion: 'Combien de cartons y\'a t-il à déménager ?',
  numberOfPersonQuestion: 'Combien de personnes sont concernées par le déménagement ?',
  chooseCorrespondingPack: 'Sélectionnez le nombre de cartons le mieux adapté à votre situation :',
  unclutteredFlat: 'Appartement épuré',
  clutteredFlat: 'Appartement très meublé',
  standardFlat: 'Appartement standard',
  standardBox: 'Cartons standards',
  booksBox: 'Cartons livres',
  clothBox: 'Cartons penderies',
  totalBoxToCarry: 'Cartons à déménager',
};
